<template>
  <div>
    <div>
      <DataListStateful
        title="Запросы"
        resource="shipment-requests"
        store="clientDashboardRequests"
        :columns="shipmentRequestColumns"
        :add-route="{name: 'shipment-request-new'}"
      />

      <DataListStateful
        title="Поставки"
        resource="shippings"
        store="clientDashboardShippings"
        :columns="shippingColumns"
        :add-route="{name: 'shipping-new-steps'}"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shipmentRequestColumns: [
        {
          title: "Номер",
          name: "id",
          visible: true,
          isEditLink: true,
          sortable: true,
        },
        { title: "Дата запроса", name: "date", visible: true, sortable: true },
        { title: "Статус", name: "status", visible: true, sortable: true },
        {
          title: "Тип поставки",
          name: "shippingType",
          dataPath: "ShippingType.Title",
          sortable: true,
        },
        {
          title: "Менеджер",
          name: "employee",
          dataPath: "Employee.Title",
          sortable: true,
        },
        {
          title: "Клиент",
          name: "client",
          dataPath: "Client.Title",
          sortable: true,
        },
        {
          title: "Страна отправления",
          name: "sendingCountry",
          dataPath: "SendingCountry.Title",
          visible: true,
          sortable: true,
        },
        {
          title: "Продавец",
          name: "factory",
          dataPath: "Factory.Title",
          sortable: true,
        },
        { title: "Регион", name: "region", dataPath: "Region.Title" },
        { title: "Объем, м3", name: "volume" },
        { title: "Вес брутто", name: "brutto" },
        { title: "Кол-во мест", name: "cargoPlaces", sortable: true },
        {
          title: "Категория товара",
          name: "productCategory",
          dataPath: "ProductCategory.Title",
          sortable: true,
        },
        {
          title: "Город выгрузки",
          name: "unloadingCity",
          dataPath: "UnloadingCity.Title",
          sortable: true,
        },
        {
          title: "Дата готовности к отгрузке",
          name: "readyDate",
          sortable: true,
        },
        { title: "Желаемая дата доставки", name: "wantedDate", sortable: true },
        {
          title: "Запросы из того же региона/отправителя",
          name: "sameRegionRequestIds",
          sortable: true,
        },
        { title: "Обновления инфо", name: "infoUpdates", sortable: true },
      ],
      shippingColumns: [
        { title: "Номер", name: "id", isEditLink: true, sortable: true },
        {
          title: "Запрос",
          name: "ShipmentRequest",
          dataPath: "ShipmentRequest.Title",
          sortable: true,
        },
        { title: "Дата создания", name: "date", visible: true, sortable: true },
        {
          title: "Тип поставки",
          name: "shippingType",
          dataPath: "ShippingType.Title",
          sortable: true,
        },
        {
          title: "Менеджер",
          name: "manager",
          dataPath: "Manager.Title",
          sortable: true,
        },
        {
          title: "Клиент",
          name: "client",
          dataPath: "Client.Title",
          sortable: true,
        },
        {
          title: "Страна отправления",
          name: "country",
          dataPath: "Country.Title",
          visible: true,
          sortable: true,
        },
        {
          title: "Продавец",
          name: "factory",
          dataPath: "Factory.Title",
          sortable: true,
        },
        {
          title: "Город выгрузки",
          name: "unloadingCity",
          dataPath: "UnloadingCity.Title",
          sortable: true,
        },
      ],
    };
  },
};
</script>
